let plans_headers = [
  "Top Plans",
  "Discounted Plan",
  "Amount",
  "Coins",
  "Total Purchased",
  "Total Coins Sold",
  "Total Money genrated",
  "Status",
  "Action",
];

const top_ups_headers = [
  "Amount",
  "Coins",
  "Total Purchased",
  "Total Coins Sold",
  "Total Money genrated",
  "Status",
];

const custom_plan_headers = [
  "School Name",
  "Amount",
  "Coins",
  "Duration",
  "Status",
  "Action",
];

export { plans_headers, top_ups_headers, custom_plan_headers };
